<template>
  <div style="display: grid; justify-items: center">
    <div class="container2">
      <vue-resizable
        v-for="i in data.sensor"
        :key="i"
        :ref="i.ref"
        :dragSelector="dragSelector"
        :fit-parent="i.fit"
        :width="i.width"
        :height="i.height"
        :left="i.left"
        :top="i.top"
        @mount="eHandler, emove(i.ref)"
        @resize:move="eHandler"
        @resize:start="eHandler"
        @resize:end="eHandler"
        @drag:move="eHandler"
        @drag:start="eHandler, emove(i.ref)"
        @drag:end="eHandler, emove(i.ref)"
      >
        <div class="block">
          <div class="drag-container">
            <img
              style="width: 75px"
              src="@/assets/images/background/output-onlinegiftools (10).gif"
            />{{ i.ref }}
            <!-- <vs-icon icon="polymer" size="32px" color="#BC1254"></vs-icon> -->
          </div>
        </div>
      </vue-resizable>
      <div style="margin: 60px">
        <img :src="data.map" />
      </div>
    </div>
  </div>
</template>

<script>
import VueResizable from "vue-resizable";
export default {
  name: "App",
  props: ["data"],
  components: { VueResizable },
  data() {
    const tW = 32;
    const tH = 0.5;
    return {
      datalog: null,
      ac: "hide",
      data: null,
      // handlers: ["r", "rb", "b", "lb", "l", "lt", "t", "rt"],
      left: `calc( 50% - ${tW / 2}px)`,
      top: `calc(50% - ${tH / 2}px)`,
      height: tH,
      width: tW,
      // maxW: 250,
      // maxH: 250,
      // minW: 75,
      // minH: 75,
      fit: true,
      event: "",
      ref: "",
      dragSelector: ".drag-container-1, .drag-container-2",
    };
  },
  methods: {
    eHandler(data) {
      console.log(data);
      this.datalog = data;
      this.width = data.width;
      this.height = data.height;
      this.left = data.left;
      this.top = data.top;
      this.event = data.eventName;
    },
    emove(ref) {
      this.ref = ref;
    },
  },
  mounted() {
    this.data = this.$session.get("data");
  },
  filters: {
    checkEmpty(value) {
      return typeof value !== "number" ? 0 : value;
    },
  },
};
</script>


<style scoped>
.block {
  /* height: 75px;
  width: 75px; */
  /* background-color: aqua; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container2 {
  /* width: 2500px;
  height: 700px; */
  padding: 0;
  display: inline-block;
  border: 1px solid #dddddd;
  background: #ffffff;
  color: #333333;
  /* float: left; */
  margin: 10px;
}

#block1 {
  border: solid black 1px;
  height: 75px;
  width: 75px;
  display: inline-block;
  float: left;
}

.resizable {
  background-position: top left;
  width: 150px;
  height: 150px;
  padding: 0;
  border: 1px solid #003eff;
  background: #007fff;
  font-weight: normal;
  color: #ffffff;
  position: relative;
}

.table-block {
  display: table;
}

.table-row {
  display: table-row;
  text-align: center;
}

.table-cell {
  width: 50%;
  display: inline-block;
}

.table-input {
  width: 50px;
}

.drag-container {
  /* width: 100%;
  height: 20px;
  background: red;
  color: white;
  text-align: center;
  cursor: pointer; */
  /* background: #bc1254; */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.table-container {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>